import { Model } from 'miragejs'

export default {
  campaign: Model,
  coin: Model,
  offer: Model
}



// WEBPACK FOOTER //
// ./src/mocks/models/index.js